package io.horion.cv.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

@Composable
fun LoadEffect(){
    Div(
        attrs = Modifier
            .classNames("spinner-border", "text-primary")
            .toAttrs()
    ) {
        Span(
            attrs = Modifier
                .classNames("visually-hidden")
                .toAttrs()
        ) { Text("Loading...") }
    }
}